export const locale = {
  lang: 'de',
  data: {
    'ALERTS':{
      'OK':'OK'
    },
    'CIERRE': {
      'CARGANDO':'Loanding data',
      'CARGANDOCORREO':'Bitte, warten Sie einen Moment...',
      'LABEL1':'Teilnahmequote',
      'LABEL2': 'Fortschritt sehen',
      'LABEL3': 'Umfrage abgeschlossen',
      'LABEL4': 'Ergebnis sehen',
      'LABEL5': 'Die Erinnerungsmails wurden versendet',
      'LABEL6': 'Sie haben heute bereits eine E-Mail versendet',
      'LABEL7': 'Sie können erst nach dem Starttag Erinnerungen versenden',
      'LABEL8': 'Warten Sie eine Minute......',
      'LABEL9': 'Verbleibende Tage',
      'BTN_CIERRE': 'Jetzt schließen',
      'ALERT':{
        'MESSAGE': 'Bestätigen Sie, den voraussichtlichen Umfrageabschluss durchzuführen?',
        'BTN_CONFIRM': 'Ja',
        'BTN_CANCEL': 'Nein',
        'OK':'OK',
      },
      'ALERT_RE':{
        'MESSAGE': '¿Sind Sie sicher, dass Sie die Erinnerungen senden wollen?',
        'BTN_CONFIRM': 'Ja',
        'BTN_CANCEL': 'Nein',
        'OK':'OK',
      },
      'LINK': 'Gehe zum nächsten Link, um den aktuellen Fortschritt der Umfrage zu sehen',
      'LINKENCUESTA': 'Erzeugt den Link zur Anzeige des aktuellen Fortschritts der Umfrage',
      'ACTIONS':{
        'TITULO': 'Aktionen',
        'TITULO_ACTUALIZADO': 'Erinnern',
        'TITULO_ACCESS': 'Zugang zur Umfrage',
        'WANNADO': 'Was wollen Sie tun?',
        'TITULO_VIRSMS': 'Virtuelles SMS-Portal',
        'TITULO_MYCODE': 'GetMyCode.culturalgo.com Portal',
        'TITULO_BTNMYCODE': 'Zum GetMyCode-Portal gehen',
      },
      'COMPLETO':{
        'TAG': 'Die Umfrage wurde erfolgreich beendet',
        'CARDTIT': 'Ergebnisabfrage',
        'LINK': 'Gehen Sie zum nächsten Link, um die erhaltenen Ergebnisse der Umfrage zu sehen'
      },
      'PORTAL':{
        'LABEL01':'Zählportal',
        'LABEL02':'Zugangsschlüssel generieren'

      },
      'PULSE':{
        /// Umfrage-Fortschritt
        'LABELPRO':'Umfrage-Fortschritt',
        'LINKEN': 'Umfrage-Link',
        'LINKRES': 'Verknüpfungsergebnis',
        'ENCUESTANOENVIADA': 'Es wurde noch keine Pulse Check Umfrage freigegeben',
      },
      'CIERRE':{
        'BCONTEOS': 'Zählportal',
        'BACCESO':'Zugangsschlüssel generieren',
        'LINKPORTAL':'Zugangslink zum Zählportal kopieren',
        'COPYLINK':'In die Zwischenablage kopiert',
        'REMANDERC2':'Erinnerung an Personen, die die Umfrage nicht beendet haben',
        'REMANDER':'Mahnungen',
        'REMANDER1':'Erinnerungen an Personen, die noch nicht an Ihrer Umfrage teilgenommen haben',
        'REMANDER2':'Erinnerungen an Menschen, die begonnen haben und noch nicht fertig sind',
        'REMANDER_TURQUIA':'Erinnerungen an alle Teilnehmer senden',
        'GETURLSURV_1':'Umfrage-Zugangsanbieter-Link generieren',
        'GETURLSURV_2': 'Der Link für den Umfrage-Zugangsanbieter wurde generiert, jetzt können Sie ihn durch Klicken auf die gleiche Schaltfläche kopieren',
        'GETURLSURV_3': 'Link für Umfrage-Zugangsanbieter kopieren',
        'ASIGUSERDEMO':'Passwort zuweisen',
      },
      'MOD_TEX_SEND_RECO':'E-Mail senden...',

    },
  }
};
